export function formatDimensions(
  input: {
    length?: number | null
    width?: number | null
    height?: number | null
    predefinedPackage?: string | null
  } | null,
) {
  const { length, width, height, predefinedPackage } = input || {}

  if (predefinedPackage) {
    return predefinedPackage
  }

  // `height` can sometimes be 0 (envelopes, letters, soft pack, etc.)
  if (!length || !width) return ''

  return `${length} × ${width} × ${height} in`
}
